const SingleBanner = {
  options: {
    data: {
      text: {
        type: 'Text',
        order: 1,
      },
      images: [
        {
          image: {
            src: '',
          },
          pointTo: {
            url: '',
            pointTo: '',
            pointToName: '',
            pointToType: '',
          },
        },
      ],
    },
    customization: {
      textSize: {
        type: 'RangePx',
        data: {
          max: 30,
          min: 0,
          step: 1,
        },
        order: 2,
      },
      textColor: {
        type: 'HexColor',
        order: 3,
      },
      textAlignment: {
        type: 'LeftCenterRight',
        order: 4,
      },
      textStyle: {
        type: 'SelectBox',
        data: {
          selectOptions: ['normal', 'italic'],
        },
        order: 5,
      },
      textWeight: {
        type: 'SelectBox',
        data: {
          selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        },
        order: 6,
      },
      textLetterSpacing: {
        type: 'RangePx',
        data: {
          max: 30,
          min: 0,
          step: 1,
        },
        order: 7,
      },
      backgroundSize: {
        type: 'Radio',
        order: 10,
        data: {
          direction: 'row',
          radioOptions: ['cover', 'contain', 'stretch'],
        },
      },
      boxShadow: {
        type: 'ChildComponentRenderer',
        order: 11,
        data: {
          componentNames: ['shadow1', 'shadow2', 'shadow3'],
        },
      },
    },
    widgets: {
      Tabs_1: {
        type: 'Tabs',
        order: 8,
        options: {
          containerPadding: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'edge',
            },
            type: 'FourPx',
          },
          padding: {
            data: {
              max: 20,
              min: 0,
              step: 2,
              svgType: 'edge',
            },
            type: 'FourPx',
          },
          borderRadius: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
          },
        },
      },
      ToggleRadioTabs_1: {
        type: 'ToggleRadioTabs',
        order: 9,
        renderOptions: {
          direction: 'row',
          controlKey: 'backgroundType',
        },
        options: {
          backgroundImage: {
            type: 'ImageUploader',
          },
          backgroundColor: {
            type: 'HexColor',
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'SingleBanner_1_1',
      name: 'SingleBanner_1_1',
      type: 'SingleBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        padding: '5px 0px 0px 0px',
        textSize: '13px',
        boxShadow: false,
        textColor: '#1c1c1c',
        textStyle: 'normal',
        textWeight: '600',
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'center',
        backgroundSize: 'cover',
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        containerPadding: '5px 0px 0px 0px',
        textLetterSpacing: '0px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Single+Banner+1_1%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SingleBanner_1_7_1_paddingless',
      name: 'SingleBanner_1_7_1_paddingless',
      type: 'SingleBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        padding: '5px 0px 0px 0px',
        textSize: '13px',
        boxShadow: 'shadow2',
        textColor: '#1c1c1c',
        textStyle: 'normal',
        textWeight: '600',
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'center',
        backgroundSize: 'cover',
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        containerPadding: '5px 0px 0px 0px',
        textLetterSpacing: '0px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '17/10',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Single+Banner+1.7_1%402x-1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SingleBanner_2_7_1',
      name: 'SingleBanner_2_7_1',
      type: 'SingleBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        padding: '5px 0px 0px 0px',
        textSize: '13px',
        boxShadow: 'shadow2',
        textColor: '#1c1c1c',
        textStyle: 'normal',
        textWeight: '600',
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'center',
        backgroundSize: 'cover',
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        containerPadding: '5px 0px 0px 0px',
        textLetterSpacing: '0px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '27/10',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Single+Banner+2.7_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SingleBanner_1_7_1_rounded',
      name: 'SingleBanner_1_7_1_rounded',
      type: 'SingleBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        padding: '5px 0px 0px 0px',
        textSize: '13px',
        boxShadow: 'shadow2',
        textColor: '#1c1c1c',
        textStyle: 'normal',
        textWeight: '600',
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'center',
        backgroundSize: 'cover',
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        containerPadding: '5px 0px 0px 0px',
        textLetterSpacing: '0px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '17/10',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Single+Banner+1.7_1%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SingleBanner_1_6_2',
      name: 'SingleBanner_1_6_2',
      type: 'SingleBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        padding: '5px 0px 0px 0px',
        textSize: '13px',
        boxShadow: 'shadow2',
        textColor: '#1c1c1c',
        textStyle: 'normal',
        textWeight: '600',
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'center',
        backgroundSize: 'cover',
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        containerPadding: '5px 0px 0px 0px',
        textLetterSpacing: '0px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '16/20',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Single+Banner+1.6_2%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SingleBanner_1_5_1',
      name: 'SingleBanner_1_5_1',
      type: 'SingleBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        padding: '5px 0px 0px 0px',
        textSize: '13px',
        boxShadow: 'shadow2',
        textColor: '#1c1c1c',
        textStyle: 'normal',
        textWeight: '600',
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'center',
        backgroundSize: 'cover',
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        containerPadding: '5px 0px 0px 0px',
        textLetterSpacing: '0px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '15/10',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Single+Banner+1.5_1%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SingleBanner_full',
      name: 'SingleBanner_full',
      type: 'SingleBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        padding: '0px 0px 0px 0px',
        textSize: '13px',
        boxShadow: 'shadow2',
        textColor: '#1c1c1c',
        textStyle: 'normal',
        textWeight: '600',
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'center',
        backgroundSize: 'cover',
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        containerPadding: '0px 0px 0px 0px',
        textLetterSpacing: '0px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/2',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/singleBannerFull.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SingleBanner_dynamic',
      name: 'SingleBanner_dynamic',
      type: 'SingleBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        padding: '0px 0px 0px 0px',
        textSize: '13px',
        boxShadow: 'shadow2',
        textColor: '#1c1c1c',
        textStyle: 'normal',
        textWeight: '600',
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'center',
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        containerPadding: '0px 0px 0px 0px',
        textLetterSpacing: '0px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/singleBannerFullDynamic.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
  globalSettings: {
    canUploadVideo: true,
  },
};
export default SingleBanner;
